import React from 'react';
import { connect } from 'react-redux';
import { AlWpTemplateRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlWpTemplate extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    {this.props.activities.map(activity => (
                        <AlWpTemplateRow
                            key={activity.WPCNO}
                            wpc={activity}
                            childrens={activity.children}
                        />
                    ))}
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    const wpcs = Object.values(state.entities.notes.WPALTEMPLATE || {});
    const wpss = Object.values(state.entities.notes.WPALTEMPLATEHEADERS || {});
    const items = Object.values(state.entities.notes.WPALTEMPLATEITEMS || {});


    // Find all orphan items (items with no parent header) once
    const allOrphanItems = items
        .filter(item => {
            if (item.NoteId !== noteId) return false;

            // If item has no parent header, it's an orphan
            if (item.XLTMPWPWPSNO === null || item.XLTMPWPWPSNO === undefined) return true;

            // Check if the WPSNO exists in any WPS headers for this note
            return !wpss.some(wps => wps.WPSNO === item.XLTMPWPWPSNO && wps.NoteId === noteId);
        })
        .sort((a, b) => a.XLTMPWPORDER - b.XLTMPWPORDER);

    const activities = wpcs
        .filter(wpc => wpc.NoteId === noteId)
        .sort((a, b) => a.WPCORDER - b.WPCORDER)
        .map(wpc => {
            const childHeaders = wpss
                .filter(wps => wps.NoteId === noteId && wps.WPSWPCNO === wpc.WPCNO)
                .sort((a, b) => a.WPSORDER - b.WPSORDER)
                .map(wps => {
                    const childItems = items
                        .filter(item => item.NoteId === noteId && item.XLTMPWPWPSNO === wps.WPSNO)
                        .sort((a, b) => a.XLTMPWPORDER - b.XLTMPWPORDER);

                    return {
                        ...wps,
                        children: childItems
                    };
                });

            return {
                ...wpc,
                children: childHeaders
            };
        });

    // Create a separate section for orphan items if there are any
    if (allOrphanItems.length > 0) {
        const orphanSection = {
            WPCNO: 'ORPHAN_ITEMS',
            WPCNAME: 'Items',
            children: [],
            orphanItems: allOrphanItems,
            isOrphanSection: true
        };
        activities.push(orphanSection);
    }

    return {
        activities: activities
    };
}

const connectedAlWpTemplate = connect(mapStateToProps)(AlWpTemplate);
export { connectedAlWpTemplate as AlWpTemplate };

